import { Box, ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { Translate } from "src/assets/data/index";
import SeaWaveFillIcon from "src/components/ui/svgIcon/SeaWaveFillIcon";
import PrimaryHoverEffect from "src/components/ui/warehouse/primaryHoverEffect";
import { AquaticMenuBox } from "../MenuStyle";
import AquaticModalSection from "./AquaticModalSection";

const AquaticSection = (menu) => {
  const theme = useTheme();
  const [anchorAquaticEl, setAnchorAquaticEl] = useState(null);

  const openAquatic = Boolean(anchorAquaticEl);
  // const refAquatic = useRef();

  const handleAquaticClick = (event) => {
    setAnchorAquaticEl(event.currentTarget);
  };
  const handleAquaticClose = () => setAnchorAquaticEl(null);

  return (
    <Box>
      <Stack sx={{ justifyContent: "space-around", height: 80 }}>
        <Stack flexDirection="row" justifyContent="center" alignItems="center" height={0.5}>
          <PrimaryHoverEffect heighteffect={80} className={openAquatic ? "active" : ""}>
            {/* <Box sx={{ position: "absolute", top: "-130%", left: "12%" }} /> */}
            <ButtonBase
              variant="text"
              onClick={handleAquaticClick}
              sx={{ transform: "rotate(90deg)", minWidth: "unset", color: "text.primary", p: 0.5 }}
            >
              <Typography variant="body2" sx={{ marginInlineEnd: 1 }}>
                {Translate.translate.texts.aquatic}
              </Typography>
              <SeaWaveFillIcon sx={{ transform: "rotateZ(90deg)" }} color={theme.palette.text.primary} />
            </ButtonBase>
          </PrimaryHoverEffect>

          <AquaticMenuBox anchorEl={anchorAquaticEl} open={openAquatic} onClose={handleAquaticClose}>
            <AquaticModalSection menu={menu} handleClose={handleAquaticClose} type="aquatic" />
          </AquaticMenuBox>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AquaticSection;
